module.exports = "<div class=uim-widget><div class=uim-reset-password></div><div class=uim-invalid-token></div></div>";


//////////////////
// WEBPACK FOOTER
// ./components/ui-widgets/src/html/ResetPassword.html
// module id = 22
// module chunks = 0